<template>
  <b-container>
    <h1>Les cabinets</h1>
    <b-row class="justify-content-center">
      <Cabinet
        v-for="cabinet in cabinets"
        :key="cabinet.name"
        :name="cabinet.name"
        :photos="cabinet.photos"
        :description="cabinet.description"
        :horaire="cabinet.horaire"
        :adresse="cabinet.adresse"
        :logo="cabinet.logo"
      ></Cabinet>
    </b-row>
    <div class="map">
      <h2>S'y rendre</h2>
      <Map />
    </div>
  </b-container>
</template>

<style scoped>
.map {
  margin-top: 30px;
}
</style>

<script>
import Cabinet from "../components/Cabinet";
import Map from "../components/Map";
export default {
  data() {
    return {
      cabinets: [
        {
          logo: "aurore.jpg",
          photos: [
            "image23.jpg",
            "image5.jpg",
            "image8.jpg",
            "image31.jpg",
            "image27.jpg",
            "image10.jpg",
            "image11.jpg",
          ],
          description:
            "Le cabinet d’orthoptie fait partie du pôle de santé interprofessionnel universitaire de Saint Martin d’Hères,  avec lequel nous partageons des protocoles et des projets innovants  (l'ambition étant de travailler collectivement à la réduction des inégalités sociales de santé) Nous disposons de trois salles de rééducation et d’une salle d’examen de vue.  Nous pouvons effectuer tous les types de bilans et examens dans ce cabinet. Il est accessible PMR (personne à mobilité réduite) (sauf la salle d’examen de vue).",
          name: "Le cabinet de l’Aurore à St Martin d’Hères",
          horaire: "Du lundi au vendredi de 9h à 19h.",
          adresse:
            "Le cabinet est situé sur la place piétonne Frida Kahlo, au numéro 9, derrière l’immeuble en demi-cercle ou se trouve la pharmacie / le coiffeur/ la pizzeria.",
        },
        {
          logo: "magelys.jpg",
          photos: ["image37.jpg"],
          description:
            "Le cabinet d’orthoptie de Jarrie a fermé définitivement ses portes en Février 2023. Vous retrouverez toute l'équipe au cabinet de Saint Martin d'Hères",
          name: "Le cabinet MAGELYS à Jarrie",
          horaire: "Fermé définitivement.",
          adresse: "",
        },
      ],
    };
  },
  components: {
    Cabinet,
    Map,
  },
};
</script>
